import * as t from './actionTypes';

export const updateCatalogItemRequest = (params: Record<string, any>) => ({
  type: t.UPDATE_CATALOG_ITEM_REQUEST,
  ...params,
});

export const updateCatalogItemResponse = (
  pending: Record<string, any>,
  pendingDelete: Record<string, any>,
) => ({
  type: t.UPDATE_CATALOG_ITEM_RESPONSE,
  pending,
  pendingDelete,
});

export const updateCatalogItemError = (error: string | Record<string, any>) => ({
  type: t.UPDATE_CATALOG_ITEM_ERROR,
  error,
});

export const updateFieldsAndCatalogItemRequest = (params: Record<string, any>) => ({
  type: t.UPDATE_FIELDS_AND_CATALOG_ITEM_REQUEST,
  ...params,
});

// TODO might not need this
export const updateFieldsAndCatalogItemResponse = () => ({
  type: t.UPDATE_FIELDS_AND_CATALOG_ITEM_RESPONSE,
});

// TODO might not need this
export const updateFieldsAndCatalogItemError = () => ({
  type: t.UPDATE_FIELDS_AND_CATALOG_ITEM_ERROR,
});

export const updateBulkCatalogItemsRequest = (params: Record<string, any>) => ({
  // params will have tableName and csv blob
  type: t.UPDATE_BULK_CATALOG_ITEMS_REQUEST,
  ...params,
});

export const updateBulkCatalogItemsResponse = (message: string) => ({
  type: t.UPDATE_BULK_CATALOG_ITEMS_RESPONSE,
  message,
});

export const updateBulkCatalogItemsError = (error: string | Record<string, any>) => ({
  type: t.UPDATE_BULK_CATALOG_ITEMS_ERROR,
  error,
});

export const updateFieldsAndBulkCatalogItemsRequest = (params: Record<string, any>) => ({
  type: t.UPDATE_FIELDS_AND_BULK_CATALOG_ITEMS_REQUEST,
  ...params,
});

// TODO might not need this
export const updateFieldsAndBulkCatalogItemsResponse = () => ({
  type: t.UPDATE_FIELDS_AND_BULK_CATALOG_ITEMS_RESPONSE,
});

// TODO might not need this
export const updateFieldsAndBulkCatalogItemsError = () => ({
  type: t.UPDATE_FIELDS_AND_BULK_CATALOG_ITEMS_ERROR,
});

export const skipFieldDefinition = () => ({
  type: t.SKIP_FIELD_DEFINITION,
});

export const skipFieldDefinitionAndUploadToCatalog = () => ({
  type: t.SKIP_FIELD_DEFINITION_AND_UPLOAD_ONLY,
});

export const csvKeyMissing = () => ({ type: t.CSV_KEY_MISSING });
export const uploadSizeExceeded = () => ({ type: t.UPLOAD_SIZE_EXCEEDED });
